import React from 'react';
import {
  Box, IconButton, Typography, Tooltip, Card, CardMedia, CardContent, CardActions,
} from '@material-ui/core';
import {
  Visibility, ArrowDropDown, ArrowDropUp, CameraAlt,
} from '@material-ui/icons';
import { clustersNames } from '@auteco/constants';
import { useStyles, Button } from './styles';
import randomImg from '../../../assets/images/iconoWiki.svg';


const InsightDetails = (props) => {
  const {
    insight,
    files,
    goBack,
    fetchUrl,
    unidades,
    onDeleteInsight,
    permitValue,
    onEdit,
    onOpenResult,
    onLike,
    onPostImage,
    insightImg,
  } = props;

  // const [show, element] = useNearScreen();
  const classes = useStyles();
  const fechaCreacion = insight.fecha_creacion?.slice(0, 10);
  const unidadNegocio = unidades?.filter((unidad) => unidad.id === insight.id_unidad_negocio).pop();
  const tipoInsigth = (idTipoEntrada) => {
    switch (idTipoEntrada) {
      case '1':
        return 'Fact';
      case '2':
        return 'Actionable Fact';
      case '3':
        return 'Insight';
      default:
        return 'Sin Asignar';
    }
  };
  const clusterName = clustersNames.find(cluster => cluster.id === insight?.cluster_id) || ''
  return (
    <Box className={classes.mainContainer}>
      <Card className={classes.cardContainer}>
        <CardContent className={classes.cardContent}>
          <CardMedia
            className={classes.image}
            component="img"
            image={insightImg?.urlFirmada || randomImg}
            title="Imagen Insight"
          />
          <Tooltip title="Adjuntar Imagen">
            <IconButton
              disabled={permitValue < 3}
              component="label"
              variant="contained"
              style={{ color: 'black', background: 'gainsboro' }}
              className={classes.iconButtonImg}
            >
              <CameraAlt />
              <input
                accept="image/*"
                type="file"
                hidden
                onChange={(e) => {
                  onPostImage(e.target.files);
                }}
              />
            </IconButton>
          </Tooltip>
          <Box>
            <Typography className={classes.title}>{insight.titulo}</Typography>
            <Typography className={classes.testResult}>
              {tipoInsigth(insight.id_tipo_entrada)}
            </Typography>
            <Typography className={classes.testResult}>
              {unidadNegocio?.unidad}
            </Typography>
            <Typography className={classes.testResult}>
              {' '}
              Visitas
              {' '}
              {insight.visualizaciones}
            </Typography>
          </Box>
        </CardContent>
        <CardActions className={classes.cardActions}>
          <Box>
            <Typography className={classes.testResult}>
              {insight.remitente}
            </Typography>
            <Typography className={classes.testResult}>
              {fechaCreacion}
            </Typography>
          </Box>
          <Box className={classes.buttonCont}>
            <Button disabled={permitValue < 3} onClick={onEdit}>
              Editar
            </Button>
            <Button disabled={permitValue < 4} onClick={onDeleteInsight}>
              Eliminar
            </Button>
            <Button onClick={goBack}>Volver</Button>
          </Box>
        </CardActions>
      </Card>
      <Box className={classes.reelContainer}>
        <Box className={classes.leftContainer}>
          <Card className={classes.leftCards}>
            <CardContent>
              <Typography className={classes.title}>Cluster</Typography>
              <Typography className={classes.texts}>{clusterName.name || ''}</Typography>
            </CardContent>
          </Card>
          <Card className={classes.leftCards}>
            <CardContent>
              <Typography className={classes.title}>Resumen</Typography>
              <Typography className={classes.texts}>
                {insight.resumen}
              </Typography>
            </CardContent>
          </Card>
          <Card className={classes.leftCards}>
            <CardContent>
              <Typography className={classes.title}>Detalles</Typography>
              <Typography className={classes.texts}>
                {insight.detalle}
              </Typography>
            </CardContent>
          </Card>
          <Card className={classes.leftCards}>
            <CardContent>
              <Typography className={classes.title}>Indicadores</Typography>
              <Typography className={classes.texts}>
                {insight.indicadores}
              </Typography>
            </CardContent>
          </Card>
          {files.length !== 0 ? (
            <Card className={classes.leftCards}>
              <CardContent>
                <Typography className={classes.title}>Archivos</Typography>
                {files?.map((file, index) => (
                  <Box key={file.id} className={classes.containerFiles}>
                    <Typography className={classes.textFiles}>
                      {file.nombre_adjunto}
                    </Typography>
                    <IconButton
                      className={classes.iconButton}
                      onClick={() => fetchUrl(index)}
                    >
                      <Tooltip title="Ver archivo">
                        <Visibility fontSize="small" />
                      </Tooltip>
                    </IconButton>
                  </Box>
                ))}
              </CardContent>
            </Card>
          ) : null}
        </Box>
        <Box className={classes.rightContainer}>
          <Card className={classes.leftCards}>
            <CardContent>
              <Button onClick={onOpenResult} width="fullWidth">
                Agregar resultados
              </Button>
            </CardContent>
          </Card>

          {insight.resultados?.map((resultado) => (
            <Card
              className={
                resultado.estado === '0' ? classes.statusOff : classes.leftCards
              }
              key={resultado.id}
            >
              <CardContent className={classes.cardContent}>
                <Box className={classes.imageWrap}>
                  <CardMedia
                    className={classes.resultImg}
                    component="img"
                    image={
                      insightImg?.urlFirmada || randomImg
                    }
                    title="Imagen Insight"
                  />
                  <Box>
                    <Typography className={classes.resultName}>
                      {resultado.usuarioNombre}
                    </Typography>
                    {resultado.estado === '0' ? (
                      <Typography className={classes.testResult}>
                        Pendiente de aprobación
                      </Typography>
                    ) : null}
                    <Typography className={classes.resultDate}>
                      {resultado.fecha?.slice(0, 10)}
                    </Typography>
                  </Box>
                </Box>
                <Box className={classes.likesContainer}>
                  <IconButton
                    onClick={() => onLike(resultado.id, 'like')}
                    className={classes.iconLikes}
                    disabled={resultado.estado === '0'}
                  >
                    <Tooltip title="Resultado Positivo">
                      <ArrowDropUp fontSize="large" />
                    </Tooltip>
                  </IconButton>
                  <Typography className={classes.testResult}>
                    {resultado.puntos}
                  </Typography>
                  <IconButton
                    onClick={() => onLike(resultado.id, 'dislike')}
                    className={classes.iconLikes}
                    disabled={resultado.estado === '0'}
                  >
                    <Tooltip title="Resultado Negativo">
                      <ArrowDropDown fontSize="large" />
                    </Tooltip>
                  </IconButton>
                </Box>
              </CardContent>
              <Box className={classes.lineBreak} />
              <CardContent>
                <Typography className={classes.resultDescription}>
                  {resultado.resultado}
                </Typography>
              </CardContent>
              <Box className={classes.lineBreak} />
              <CardContent className={classes.contentRFiles}>
                {resultado.adjuntos?.map((adjunto, index) => (
                  <Box key={adjunto.id} className={classes.containerRFiles}>
                    <Typography className={classes.textRFiles}>
                      {adjunto.nombre_adjunto}
                    </Typography>
                    <IconButton
                      className={classes.iconButton}
                      onClick={() => fetchUrl(index, adjunto.urlFirmada)}
                    >
                      <Tooltip title="Ver archivo">
                        <Visibility fontSize="small" />
                      </Tooltip>
                    </IconButton>
                  </Box>
                ))}
              </CardContent>
            </Card>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default InsightDetails;
